import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['scoreButton', 'comment', 'submitButton', 'error']

  static values = {
    apiUrl: String,
    thanksUrl: String,
  }

  connect() {
    this.selectedScore = null
  }

  selectScore(event) {
    const button = event.currentTarget
    const score = parseInt(button.dataset.score, 10)

    if (Number.isNaN(score)) return

    this.applyScore(score)
    button.focus()
  }

  handleKeydown(event) {
    const buttons = this.scoreButtonTargets
    const currentIndex = buttons.indexOf(event.currentTarget)
    if (currentIndex === -1) return

    let nextIndex = null
    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % buttons.length
        break
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + buttons.length) % buttons.length
        break
      case 'Home':
        nextIndex = 0
        break
      case 'End':
        nextIndex = buttons.length - 1
        break
      default:
        return
    }

    event.preventDefault()
    const nextButton = buttons[nextIndex]
    const nextScore = parseInt(nextButton.dataset.score, 10)
    this.applyScore(nextScore)
    nextButton.focus()
  }

  applyScore(score) {
    this.selectedScore = score
    this.scoreButtonTargets.forEach((b) => {
      const isSelected = parseInt(b.dataset.score, 10) === score
      b.classList.toggle('active', isSelected)
      b.setAttribute('aria-checked', isSelected ? 'true' : 'false')
      b.setAttribute('tabindex', isSelected ? '0' : '-1')
    })
    this.submitButtonTarget.disabled = false
    this.hideError()
  }

  async submit() {
    if (this.selectedScore === null) {
      this.showError('Please pick a score from 0 to 10.')
      return
    }

    this.submitButtonTarget.disabled = true

    const csrfMeta = document.querySelector('meta[name="csrf-token"]')
    const csrfToken = csrfMeta ? csrfMeta.content : ''

    try {
      const response = await fetch(this.apiUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({
          nps_response: {
            score: this.selectedScore,
            comment: this.hasCommentTarget ? this.commentTarget.value : null,
          },
        }),
      })

      if (response.ok) {
        window.location.href = this.thanksUrlValue
        return
      }

      const data = await response.json().catch(() => ({}))
      const message = (data.errors && data.errors.join(' ')) || 'Something went wrong. Please try again.'
      this.showError(message)
      this.submitButtonTarget.disabled = false
    } catch (error) {
      console.error('NPS submit failed', error)
      this.showError('Network error. Please try again.')
      this.submitButtonTarget.disabled = false
    }
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove('d-none')
  }

  hideError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.classList.add('d-none')
    this.errorTarget.textContent = ''
  }
}
